import { ElementRef, Injectable } from '@angular/core';
import { BehaviorSubject, from, Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import html2canvas, { Options } from 'html2canvas';

export enum CustomAttributes {
  skipSummaryImageRender = 'data-skip-summary-image-render',
  html2CanvasIgnoreElement = 'data-html2canvas-ignore',
}

@Injectable({ providedIn: 'root' })
export class ImageCaptureService {
  private _WIDTH_MODIFIER: number = 0.75;
  private _isCapturing$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public get isCapturing(): Observable<boolean> {
    return this._isCapturing$.asObservable();
  }

  public getWidth(captureContainer: ElementRef): number {
    const { width }: { [key: string]: number } = captureContainer.nativeElement.getBoundingClientRect();

    return width * this._WIDTH_MODIFIER;
  }

  public getHeight(captureContainer: ElementRef): number {
    const { height }: { [key: string]: number } = captureContainer.nativeElement.getBoundingClientRect();

    return height;
  }

  public setIsCapturing(value: boolean): void {
    this._isCapturing$.next(value);
  }

  public createDataUrlFrom(captureContainer: ElementRef): Observable<string> {
    const options: Partial<Options> = {
      width: this.getWidth(captureContainer),
      height: captureContainer.nativeElement.offsetHeight,
    };

    return from(html2canvas(captureContainer.nativeElement, options)).pipe(
      map((canvas) => {
        const dataUrl = canvas.toDataURL('image/png');

        return dataUrl;
      }),
      catchError((error) => {
        this.setIsCapturing(false);

        return throwError(error);
      }),
      finalize(() => {
        this.setIsCapturing(false);
      }),
    );
  }
}
